export const getFacilityTypeName = (code) => {
    switch (code) {
        case '03':
            return 'VDS'
        case '07':
            return 'CCTV'
        case '08':
            return 'VMS'
        case '12':
            return '영상VDS'
        case '17':
            return 'DSRC'
        case '80':
            return '스마트교차로'
        case '99':
            return '소통정보'
        default:
            return '알수없음'
    }
}